module.exports = __webpack_public_path__ + "static/media/mihir.81e9d4fc.jpeg";